function dateDiff(endDate, startDate, interval) {
  if (typeof endDate === 'string') {
    endDate = new Date(endDate)
  }

  if (typeof startDate === 'string') {
    startDate = new Date(startDate)
  }

  switch (interval) {
    case 's':
      return Math.round((endDate - startDate) / 1000)
    case 'm':
      return Math.round((endDate - startDate) / 60000)
    case 'h':
      return Math.round((endDate - startDate) / 3600000)
    case 'd':
      return Math.round((endDate - startDate) / 86400000)
    case 'w':
      return Math.round((endDate - startDate) / (86400000 * 7))
    case 'M':
      return (
        endDate.getMonth() +
        1 +
        (endDate.getFullYear() - startDate.getFullYear()) * 12 -
        (startDate.getMonth() + 1)
      )
    case 'y':
      return endDate.getFullYear() - startDate.getFullYear()
  }
}

export default dateDiff
